var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"drop-navigation","appear":""}},[_c('div',{staticClass:"drop-nav"},[(_vm.currentPanel < 3)?[_c('ul',_vm._l((_vm.panels),function(panel,index){return _c('li',{class:index === _vm.currentPanel ? 'is-active' : '',on:{"click":function($event){_vm.panelChange(index)}}})}))]:_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0074a6f8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panels/DropNavigation.vue
// module id = 243
// module chunks = 0